import { createAction } from '@reduxjs/toolkit';
import { TeammatesSortBy } from '../../api/teammates/types';

export const setTeammatesKeyword = createAction<string>('SET_TEAMMATES_KEYWORD');

export const setCustomTeammatePermissionModal = createAction<number | null>('SET_CUSTOM_TEAMMATE_PERMISSION_MODAL');

export const setTeammatesSort = createAction<TeammatesSortBy | undefined>('SET_TEAMMATES_SORT');
